/**
 * Gets the focused view filter for the given table
 * @returns the focused view filter
 */
export default function getFocusedFilterForTable(tableView) {
    switch (tableView.tableQuery.type) {
        case 0 /* Folder */:
        case 2 /* Group */:
            return tableView.tableQuery.focusedViewFilter;
        case 1 /* Search */:
            return -1 /* None */;
        default:
            throw new Error('Table Query should be either of type search, mail folder or group');
    }
}
//# sourceMappingURL=getFocusedFilterForTable.js.map